module.exports = __webpack_public_path__ + "1e0206ff2697f9417eead27f9a3b126d.png";